import Reveal from '@/components/base/Reveal';
import { characters } from '@/mocks/comicData';

const avatarStyles: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 ring-primary-200',
  accent: 'bg-accent-100 text-accent-700 ring-accent-200',
  secondary: 'bg-secondary-100 text-secondary-800 ring-secondary-200',
};

export default function Characters() {
  return (
    <section id="characters" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              角色介绍
              <span className="h-px w-8 bg-primary-500" />
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black md:text-4xl">巷子里的那些人</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              杂货铺的故事靠人撑起。几位核心角色各怀心事，他们的相遇与选择，共同构成了这部作品的温度。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {characters.map((c, i) => (
            <Reveal key={c.name} delay={i * 70}>
              <div className="group h-full rounded-lg border border-background-200/70 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200">
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-full font-heading text-lg font-black ring-2 ${avatarStyles[c.color]}`}
                  >
                    {c.name.charAt(0)}
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold">{c.name}</h3>
                    <span className="text-xs text-foreground-600">{c.role}</span>
                  </div>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-foreground-700">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}